import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  list: {
    padding: 0,
    width: '100%',
    backgroundColor: '#fff',
  },

  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px 16px',
    borderBottom: 'none',
    gap: 8,
    '&:hover': {
      backgroundColor: '#fafbff',
    },
  },

  avatar: {
    width: 52,
    height: 52,
    backgroundColor: '#eef3ff',
    color: '#5282ff',
    fontSize: 25,
  },

  eventContent: {
    minWidth: 0,
    marginTop: 2,
  },

  eventTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#171717',
    lineHeight: 1.5,
  },

  eventDescription: {
    marginTop: 5,
  },

  description: {
    fontSize: 14,
    color: '#707080',
    lineHeight: 1.5,
  },

  eventMeta: {
    marginTop: 6,
    fontSize: 14,
    color: '#707080',
  },

  userLink: {
    color: '#477cff',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  eventActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    marginLeft: 'auto',
    paddingLeft: 16,
    minWidth: 112,
  },

  statusChip: {
    height: 36,
    borderRadius: 24,
    backgroundColor: '#e2e2e2',
    color: '#222',
    fontSize: 16,
    '& .MuiChip-label': {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },

  detailsLink: {
    color: '#477cff',
    fontSize: 15,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  // list: {
  //   overflow: 'auto',
  // },
  // listItem: {
  //   padding: theme.spacing(1),
  //   borderBottom: `1px solid ${theme.palette.divider}`,
  //   '&:last-child': {
  //     borderBottom: 'none',
  //   },
  // },
  // avatar: {
  //   backgroundColor: theme.palette.primary.main,
  //   width: theme.spacing(4),
  //   height: theme.spacing(4),
  // },
  primaryText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  typeChip: {
    height: '20px',
    fontSize: '0.75rem',
  },
  secondaryText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  // description: {
  //   marginTop: theme.spacing(0.5),
  //   fontStyle: 'italic',
  // },
  loading: {
    textAlign: 'center',
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  dateSeparator: {
    // display: 'flex',
    // alignItems: 'center',
    padding: '10px 16px 4px',
    // '&::before': { content: '""', flex: 1, height: 1, backgroundColor: '#e0e0e0', marginRight: 12 },
    // '&::after': { content: '""', flex: 1, height: 1, backgroundColor: '#e0e0e0', marginLeft: 12 },
  },
  dateSeparatorText: {
    fontSize: 16,
    fontWeight: 600,
    color: '#888',
    whiteSpace: 'nowrap',
    backgroundColor: '#fff',
    padding: '2px',
    // borderRadius: 12,
    // border: '1px solid #e0e0e0',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
  },
}));
